import React from 'react';
import { TranslationText } from './TextTranslationContainer';
import { SVGICONS } from 'config';

export const RadioOption = ({label, value, onChange, checked, id, containerStyleProps={} , labelClass = "" , ...rest}) => {
    return (
        <button
        key={id}
        className={`flex items-center outline-none border-none bg-transparent w-full h-11 ${containerStyleProps?.className || "justify-between"}`}
        style={containerStyleProps?.style}
        {...rest}
      >
        <TranslationText text={label} className={`text-16x font-medium text-dark-blue-900 ${labelClass}`} />
        {checked ?
          <SVGICONS.RadioCheck color="text-brand-base-primary" />
          :
          <SVGICONS.RadioUnCheck color="text-brand-base-primary" />
        }
      </button>
    )
}

const RadioButton = props => {
    return (
        <>
            <div className="flex items-center mt-3 w-full">
                <label htmlFor="toggleB" className="flex items-center cursor-pointer">
                    <div className="relative">
                        <input type="checkbox" id="toggleB" className="sr-only"/>
                        <div className="block bg-gray-300 w-12 h-6 rounded-full"></div>
                        <div className="dot absolute left-1 top-1 bg-white w-4 h-4 rounded-full transition"></div>
                    </div>
                    <div className="font-montserrat font-medium text-silver-dark ml-3">
                        {props.label}
                    </div>
                </label>
            </div>
        </>
    )
}
export default RadioButton;
